<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="!error&& giftCard && initialized && !giftCard.claimed" class="container text-center space-1">
  <img src="/assets/img/starbucks.png"/>
  <h2>Hey {{ giftCard.firstName }}</h2>
  <h4 class="mt-2">We are looking forward to our call! </h4>
  <h4 class="mt-2">Here is a $10.00 Starbucks card to caffeine up for it! 🎉</h4>
  <button type="button" [promiseBtn]="submitComplete" class="btn btn-admin-primary mt-4" (click)="redeemGiftCard()">Redeem Your Gift Card</button>
</div>
<div *ngIf="!error&& giftCard && initialized && giftCard.claimed" class="container text-center space-1">
  <img src="/assets/img/starbucks.png"/>
  <h2>Hey {{ giftCard.firstName }}</h2>
  <h4 class="mt-2">Your Gift card has been successfully issued! </h4>
  <h4>Please check your email/spam folder.</h4>
</div>

<div class="container text-center space-1">
  <div *ngIf="(!giftCard || error) && initialized" class="alert alert-danger" role="alert">
    <H3>Not Found</H3>
  </div>
</div>
